import $ from 'jquery';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe-ui-default';

import * as domHelper from './helpers/dom.js';

import ClassClick from './modules/ClassClick.js';
import Filter from './modules/Filter.js';

import ListContentModule from './modules/content_modules/List.js';

// helpers
domHelper.setCapabilityClasses();

// modules
var classClick = new ClassClick();

$(document).on('updateCounter', function () {
	var $globalCounters = $('.en-filter-counter--global');
	var globalCount = 0;

	$('.en-filter').each(function () {
		var filter = $(this).data('EnFilter');

		if (filter) {
			globalCount += filter.count;
		}
	});

	$globalCounters.attr('data-en-filter-count', globalCount);
});

$('.en-filter').each(function () {
	var $this = $(this);
	var filter = new Filter($this);

	$this.data('EnFilter', filter);

	filter.initCounter();
});

// content modules
$('.en-mdl-list').each(function () {
	var $this = $(this);

	$this.data('EnList', new ListContentModule($this, {
		triggerOnChange: false
	}));
}).on('beforeSendRequest', function () {
	$(this).find('.en-mdl-list_filter__close').trigger('click');
}).on('afterRequest', function () {
	$(this).find('.en-mdl-list_filter__reset').removeClass('en-hidden');
});

// plugins
$('[data-slick]').slick();

$(document).on('click', '[data-en-ps-data]', function (e) {
	var $this = $(this);
	var $items = $this.attr('data-en-ps-group') ? $('[data-en-ps-group="' + $this.attr('data-en-ps-group') + '"]') : $this.siblings('[data-en-ps-data]').andSelf();
	var index = $items.index($this);
	var items = [];
	var ps;

	$items.each(function () {
		var data = JSON.parse($(this).attr('data-en-ps-data'));

		items.push(data);
	});

	ps = new PhotoSwipe($('.pswp').get(0), PhotoSwipeUI_Default, items, {
		index: index,
		history: false,
		shareEl: true
	});
	ps.init();

	e.preventDefault();
});
